import {
  ErrorInternal,
  ErrorInternalComponent as Comp,
} from 'components/Pages/ErrorInternal';

export const ErrorInternalComponent = Comp;

export default ErrorInternal;
